import React from 'react';

const brands = [
  { name: 'ASSA ABLOY', logo: '/brands/assa.webp' },
  { name: 'TORMAX', logo: '/brands/tormax.jpg' },
  { name: 'Stanley', logo: '/brands/stanley.png' },
  { name: 'BFT', logo: '/brands/bft.webp' },
  { name: 'CAME', logo: '/brands/came.png' },
  { name: 'LIFE', logo: '/brands/life.png' },
  { name: 'NICE', logo: '/brands/nice.png' },
  { name: 'ROGER Technology', logo: '/brands/roger.webp' },
  { name: 'dormakaba', logo: '/brands/dormakaba.png' },
  { name: 'GEZE', logo: '/brands/geze.png' },
];

const BrandCard = ({ brand }) => (
  <div className="brand-card flex-shrink-0 mx-4 md:mx-6">
    <div className="bg-white/95 backdrop-blur-sm rounded-xl shadow-md border border-white/60 px-8 py-5 md:px-10 md:py-6 flex items-center justify-center min-w-[160px] md:min-w-[190px] h-[88px] md:h-[100px] transition-transform duration-300 hover:scale-105">
      <img
        src={brand.logo}
        alt={brand.name}
        className="brand-logo-gold max-h-12 md:max-h-14 w-auto max-w-[140px] md:max-w-[160px] object-contain"
        loading="lazy"
      />
    </div>
  </div>
);

const BrandMarquee = () => {
  const track = [...brands, ...brands];

  return (
    <section className="relative py-16 md:py-20 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-10 md:mb-12">
        <div className="text-center">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Brands We Collaborate With
          </h2>
          <p className="text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">
            We partner with world-leading manufacturers to provide the most reliable
            and innovative automatic door solutions.
          </p>
        </div>
      </div>

      <div className="brand-marquee-strip relative overflow-hidden">
        <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-yellow-600 via-yellow-400 to-yellow-600 z-10" />

        <div className="brand-marquee-bg absolute inset-0" />

        <div className="relative py-10 md:py-12">
          <div className="brand-marquee-fade-left" />
          <div className="brand-marquee-fade-right" />

          <div className="brand-marquee-track flex w-max">
            {track.map((brand, index) => (
              <BrandCard key={`${brand.name}-${index}`} brand={brand} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default BrandMarquee;
